import styles from './legalNotice.module.css';

const LegalNotice = () => (
  <div className={styles.legalNoticeContainer}>
    <h1>特定商取引法に基づく表記</h1>

    <h2>サービス名</h2>
    <p>Linktivity B2B 予約プラットフォーム</p>

    <h2>販売事業者</h2>
    <p>リンクティビティ株式会社</p>

    <h2>代表者名</h2>
    <p>代表取締役 孔 成龍</p>

    <h2>所在地</h2>
    <p>〒100-0011 東京都千代田区内幸町2-1-6 日比谷パークフロント 19F</p>

    <h2>お問い合わせ先</h2>
    <p>
      こちら（
      <a href="mailto:helpcenter@linktivity.co.jp">
        helpcenter@linktivity.co.jp
      </a>
      ）からお問い合わせください。
    </p>

    <h2>代金の支払方法・支払時期</h2>
    <p>
      以下のいずれかのお支払方法をご利用いただけます。各種クレジットカード・銀行振込
    </p>

    <h2>商品の引渡時期</h2>
    <p>
      購入に関するページに特別規定を置いている場合を除き、各種クレジットカードは決済完了時、銀行振込確認完了時。
    </p>

    <h2>商品等の販売価格</h2>
    <p>各商品の詳細ページをご覧ください。</p>

    <h2>送料</h2>
    <p>なし。</p>

    <h2>販売価格・送料以外に必要な料金</h2>
    <p>インターネット接続に係る通信回線等の諸費用。</p>

    <h2>販売期間・販売数量の制限</h2>
    <p>商品ページの販売期間・在庫数・チケット枚数の制限をご参照ください。</p>

    <h2>返品・キャンセル</h2>
    <p>各商品の詳細ページをご確認ください。</p>

    <h2>その他条件</h2>
    <p>
      特別な販売条件又は提供条件がある場合、各商品のページにおいて条件を表示します。
    </p>
  </div>
);

export default LegalNotice;
